module.exports = {"title":"Warning","description":"<p>Because your event is Published, this will set the visibility to “No One” for this Pricing Option so it is not accessible.</p><p>If you would like to reactivate this Pricing Option later, you can use the “Customize Pricing” button in Dates area.</p>","ok":"Ok, I understand","cancel":"Cancel"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/ConfirmDeletePrice/locales/en.json
// module id = 1628
// module chunks = 0